import { FC, ReactNode, CSSProperties } from 'react';
import { Flex, Typography } from 'antd';

const { Text } = Typography;

interface LabelValueProps {
  label: ReactNode;
  value?: ReactNode;
  children?: ReactNode;
  labelWidth?: number | string;
  colon?: boolean;
  copyable?: boolean;
  style?: CSSProperties;
  className?: string;
  gap?: number;
}

const LabelValue: FC<LabelValueProps> = ({
  label,
  value,
  children,
  labelWidth = 160,
  colon = true,
  copyable = false,
  style,
  className,
  gap = 10,
}) => {
  const content = (children ?? value) as ReactNode;

  const isCopyablePrimitive =
    typeof content === 'string' || typeof content === 'number';

  return (
    <Flex className={className} style={{ ...style }} gap={gap}>
      <div
        style={{
          flexShrink: 0,

          color: 'rgba(0,0,0,0.45)',
          fontWeight: 400,
          lineHeight: '22px',
        }}
      >
        {label}
        {colon ? ':' : null}
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        {isCopyablePrimitive ? (
          <Text copyable={copyable}>{content}</Text>
        ) : (
          (content ?? <Text type="secondary">—</Text>)
        )}
      </div>
    </Flex>
  );
};

export default LabelValue;
